//
//
//
//
//
//
//
//
//
//
//
//

import { Loading } from 'vant'

export default { components: { Loading } }
